/**
 * @name api constant
 * @author: maoliuliu
 * @email: liuliu_mao@intsig.net
 * @date: 2022/10/27 17:51
 */

const MOCK_URL = "https://web-api.intsig.net/mock/102/base-admin" // mocK平台的url
const MOCK_URL2 = "https://web-api.intsig.net/mock/707" // mocK平台的url
const SSO_REDIRECT = "https://web-sso-sandbox.intsig.net" // sso平台的url
const SSO_URL = "https://webapi-sso-sandbox.intsig.net"
const SSO_URL2 = "https://webapi-sso-sandbox.intsig.net"
const PLATFORM_ID = "2640GeQOJK7yJRBKFXWQmhfZAo8jP6YK" // 平台id，每一个平台需要让sso平台提供一个唯一的平台id
// const BASE_URL = 'https://web-api.intsig.net/mock/108'
const BASE_URL = "https://webapi-sandbox.intsig.net/internal-property"
const ACCOUNT_URL = "https://webapi-account-sandbox.intsig.net/"
const PERMISSION_URL = "https://webapi-permission-test.intsig.net"
const SDL_URL = "https://webapi-sdl-test.intsig.net"

const WXAPPID = 1000106
export default {
    BAPI: BASE_URL,
    MAPI: MOCK_URL,
    MAPI2: MOCK_URL2,
    SRED: SSO_REDIRECT,
    PID: PLATFORM_ID,
    SAPI: SSO_URL,
    SAPI2: SSO_URL2,
    WXAPPID,
    ACC: ACCOUNT_URL,
    PAPI: PERMISSION_URL,
    SDL_URL
}
